import React, { useEffect, useRef, useState } from "react";
import { manageEnvelopeSetting } from "../../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../../utils";
import {
  DATE_FORMAT_LIST,
  NAME_CONVENTION,
  OVERDUE_REMINDER,
  PASSWORD_LIST,
  SEND_REMINDER
} from "../../../../../configs/AppConfig";
import { Lang } from "../../../../../lang";
import DatePicker from "react-datepicker";
import { default as ReactSelect } from "react-select";

function EnvSetting(props) {
  const [envelopeName, setEnvelopeName] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [pastDate, setPastDate] = useState(new Date());
  const [nameConvention, setNameConvention] = useState(1);
  const [cloudSync, setCloudSync] = useState([]);
  const [sendReminder, setSendReminder] = useState(0);
  const [overdueReminder, setOverdueReminder] = useState(0);
  const [isPassword, setIsPassword] = useState(0);
  const [password, setPassword] = useState('');
  const [referenceId, setReferenceId] = useState('');

  const dueDateRef = useRef(null);
  const openCloudStorageRef = useRef(null);

  let errorsObj = {
    name: '',
    due_date: '',
    name_convention: '',
    password: '',
  };
  const [errors, setErrors] = useState(errorsObj);

  useEffect(function () {
    setPastDate(Utils.pastDate());

    if (props?.envelopeData) {
      setEnvelopeName((props?.envelopeData.envelope_name) ? props?.envelopeData.envelope_name : '');
      setDueDate((props?.envelopeData.due_date) ? props?.envelopeData.due_date : '');
      setNameConvention((props?.envelopeData.name_convention) ? props?.envelopeData.name_convention : 1);
      setSendReminder((props?.envelopeData.send_reminder) ? props?.envelopeData.send_reminder : 0);
      setOverdueReminder((props?.envelopeData.over_due_reminder) ? props?.envelopeData.over_due_reminder : 0);
      setIsPassword((props?.envelopeData.password) ? 1 : 0);
      setPassword((props?.envelopeData.password) ? props?.envelopeData.password : '');
      setReferenceId((props?.envelopeData.reference_id) ? props?.envelopeData.reference_id : '');

      let csId = (props?.envelopeData.cloud_sync) ? props?.envelopeData.cloud_sync : 0;
      const array = String(csId).split(",").map(Number);

      if (props?.syncStatusList && props?.syncStatusList.length > 0) {
        const csIndex = array.map((value) =>
          props?.syncStatusList.find(x => parseInt(x.id) === value)
        );
        setCloudSync(csIndex.map((value) => value));
      }
    }
  }, [props]);

  const handleEnvSettingForm = (e) => {
    e.preventDefault();
    let errorObj = { ...errorsObj };
    let error = false;

    if (!envelopeName) {
      errorObj.name = 'Please enter name';
      error = true;
    }
    if (!dueDate) {
      errorObj.due_date = 'Please select date';
      error = true;
    }
    if (!nameConvention) {
      errorObj.name_convention = 'Please select option';
      error = true;
    }
    if (parseInt(isPassword) === 1 && !password) {
      errorObj.password = 'Please enter password';
      error = true;
    }

    setErrors(errorObj);

    if (error) return;

    const cloudOption = (cloudSync.map((i) => i.id).join(','));

    let obj = {
      id: props.envelopeData.id,
      name: envelopeName,
      due_date: dueDate,
      name_convention: nameConvention,
      cloud_sync: cloudOption,
      send_reminder: sendReminder,
      over_due_reminder: overdueReminder,
      reference_id: referenceId
    };

    if (parseInt(isPassword) === 1) {
      obj.password = password;
    } else {
      obj.password = '';
    }

    props.setLoading(true);

    manageEnvelopeSetting(obj)
      .then(response => {
        let envData = { ...props.envelopeData };
        envData.envelope_name = envelopeName;
        envData.due_date = dueDate;
        envData.name_convention = nameConvention;
        envData.cloud_sync = cloudOption;
        envData.send_reminder = sendReminder;
        envData.over_due_reminder = overdueReminder;
        envData.password = password;
        envData.reference_id = referenceId;
        props.setEnvelopeData(envData);

        props.setLoading(false);

        toast.success(response.data.message);
      })
      .catch(err => {
        props.setLoading(false);
        if (err.response.status === 415) {
          openCloudStorageRef?.current.click();
        } else {
          toast.error(Utils.getErrorMessage(err));
        }
      });
  };

  const handlePassword = (e) => {
    setIsPassword(e.target.value);
    setPassword('');
  };

  const showDate = (date) => {
    let dateFormat = '';
    if (date) {
      dateFormat = new Date(date);
    }
    return dateFormat;
  };

  const showDateFormat = (id) => {
    let value = '';
    let index = DATE_FORMAT_LIST.findIndex(x => parseInt(x.id) === parseInt(id));
    if (index > -1) {
      value = DATE_FORMAT_LIST[index]['format'];
    }
    return value;
  };

  const showDatePlaceholder = (id) => {
    let value = '';
    let index = DATE_FORMAT_LIST.findIndex(x => parseInt(x.id) === parseInt(id));
    if (index > -1) {
      value = DATE_FORMAT_LIST[index]['text'];
    }
    return value;
  };

  const cloudeStoragehandleChange = (selectedValues) => {
    if (selectedValues.length > 0) {
      let index = selectedValues.length - 1;
      if (selectedValues[index].id === 0) {
        setCloudSync([{ id: 0, value: "Disabled" }]);
      } else {
        let idx = selectedValues.findIndex(x => x.id === 0);
        if (idx > -1) {
          selectedValues.splice(idx, 1);
        }
        setCloudSync(selectedValues);
      }
    } else {
      setCloudSync([{ id: 0, value: "Disabled" }]);
    }
  };

  return (
    <div className="tab-pane fade" id="EnvSetting" role="tabpanel" aria-labelledby="EnvSetting-tab">
      <div className="settings-wrapper">
        {/* Header Section */}
        <div className="settings-header">
          <div className="header-content">
            <div className="header-icon">
              <i className="bi bi-gear-fill" style={{ fontSize: '32px' }}></i>
            </div>
            <div className="header-text">
              <h2>Sleeves Settings</h2>
              <p>Configure your sleeve preferences and notifications</p>
            </div>
          </div>
        </div>

        {/* Main Settings Content */}
        <div className="settings-content">
          <div className="settings-grid">
            {/* Basic Information Card */}
            <div className="settings-card">
              <div className="card-header">
                <i className="bi bi-person-badge" style={{ fontSize: '20px' }}></i>
                <h3>Basic Information</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group row">
                      <label className="col-12 col-md-4">Sleeves Name :</label>
                      <div className="input-wrapper col-12 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          value={envelopeName}
                          onChange={(e) => setEnvelopeName(e.target.value)}
                          placeholder="Enter sleeve name"
                        />
                        <i className="bi bi-info-circle ms-2 text-muted cursor-pointer" data-toggle="tooltip" data-bs-placement="right" title={Lang.env_envelope_name}></i>
                      </div>
                      {errors.name && <div className="error-message">{errors.name}</div>}
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="form-group row">
                      <label className="col-12 col-md-4">Reference ID :</label>
                      <div className="input-wrapper col-md-6 col-12">
                        <input
                          type="text"
                          className="form-control"
                          value={referenceId}
                          onChange={(e) => setReferenceId(e.target.value)}
                          placeholder="Enter reference ID"
                        />
                        <i className="bi bi-info-circle ms-2 text-muted cursor-pointer" data-toggle="tooltip" data-bs-placement="right" title="Give unique Reference ID for your Sleeve"></i>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-12">
                    <div className="form-group row">
                      <label className="col-12 col-md-2">Naming Convention :</label>
                      <div className="input-wrapper col-md-6 col-12">
                        <select
                          className="form-select"
                          value={nameConvention}
                          onChange={(e) => setNameConvention(e.target.value)}
                        >
                          {NAME_CONVENTION.map((item, index) =>
                            <option key={index} value={item.id}>{item.value}</option>
                          )}
                        </select>
                        <i className="bi bi-info-circle ms-2 text-muted cursor-pointer" data-toggle="tooltip" data-bs-placement="right" title={Lang.env_naming_convention}></i>
                      </div>
                      {errors.name_convention && <div className="error-message">{errors.name_convention}</div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Timeline Settings Card */}
            <div className="settings-card">
              <div className="card-header">
                <i className="bi bi-calendar-event" style={{ fontSize: '20px' }}></i>
                <h3>Timeline Settings</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label className="col-12 col-md-4">Due Date :</label>
                      <div className="input-wrapper date-wrapper col-md-6 col-12">
                        <div className="position-relative">
                          <DatePicker
                            selected={showDate(dueDate)}
                            dateFormat={showDateFormat(1)}
                            minDate={new Date()}
                            ref={dueDateRef}
                            className="form-control"
                            placeholderText={showDatePlaceholder(1)}
                            onChange={(date) => setDueDate(date)}
                            popperPlacement="bottom-start"
                            portalId="root-portal"
                            popperModifiers={[
                              {
                                name: "preventOverflow",
                                options: {
                                  boundary: "viewport",
                                },
                              },
                            ]}
                          />
                          <span className="date-icon" onClick={() => dueDateRef?.current?.setFocus()}>
                            <i className="bi bi-calendar-date" style={{ fontSize: '16px' }}></i>
                          </span>
                        </div>
                      </div>
                      {errors.due_date && <div className="error-message">{errors.due_date}</div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Notification Settings Card */}
            <div className="settings-card">
              <div className="card-header">
                <i className="bi bi-bell-fill" style={{ fontSize: '20px' }}></i>
                <h3>Notification Settings</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group row">
                      <label className="col-12 col-md-4">Send Reminder (Email) :</label>
                      <div className="input-wrapper col-md-6 col-12">
                        <select
                          className="form-select"
                          value={sendReminder}
                          onChange={(e) => setSendReminder(e.target.value)}
                        >
                          {SEND_REMINDER.map((item, index) =>
                            <option key={index} value={item.id}>{item.value}</option>
                          )}
                        </select>
                        <i className="bi bi-info-circle ms-2 text-muted cursor-pointer" data-toggle="tooltip" data-bs-placement="right" title={Lang.env_send_reminder}></i>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="form-group row">
                      <label className="col-12 col-md-4">Overdue Reminder (Email) :</label>
                      <div className="input-wrapper col-md-6 col-12">
                        <select
                          className="form-select"
                          value={overdueReminder}
                          onChange={(e) => setOverdueReminder(e.target.value)}
                        >
                          {OVERDUE_REMINDER.map((item, index) =>
                            <option key={index} value={item.id}>{item.value}</option>
                          )}
                        </select>
                        <i className="bi bi-info-circle ms-2 text-muted cursor-pointer" data-toggle="tooltip" data-bs-placement="right" title={Lang.env_overdue_reminder}></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div >

            {/* Integration Settings Card */}
            <div className="settings-card " >
              <div className="card-header">
                <i className="bi bi-cloud-arrow-up-fill" style={{ fontSize: '20px' }}></i>
                <h3>Integration Settings</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="input-wrapper col-md-6 col-12">
                    <ReactSelect
                      className="w-100 intigraiotn_select"
                      value={cloudSync}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      onChange={cloudeStoragehandleChange}
                      options={props?.syncStatusList}
                      getOptionLabel={(options) => options['value']}
                      menuPortalTarget={document.body}
                      menuPosition="absolute"
                    />
                    <i
                      className="bi bi-info-circle ms-2 text-muted cursor-pointer"
                      data-toggle="tooltip"
                      data-bs-placement="right"
                      data-bs-container="body"
                      title={Lang.env_cloud_sync}
                    ></i>
                  </div>
                </div>
              </div >
            </div >
          </div >

          {/* Save Button Section */}
          <div className="settings-actions" >
            <button
              type="button"
              onClick={handleEnvSettingForm}
              className="btn-save"
            >
              <i className="bi bi-save2" style={{ fontSize: '16px' }}></i>
              Save Settings
            </button>
          </div >
        </div >
      </div >

      {/* Cloud Storage Modal */}
      <span data-toggle="modal" data-bs-target="#openCloudStorage" ref={openCloudStorageRef} />
      <div className="modal fade" id="openCloudStorage" tabIndex={-1} aria-labelledby="openCloudStorageLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="cloud-storage-message">
                <i className="bi bi-cloud-slash-fill text-warning" style={{ fontSize: '48px' }}></i>
                <h4>Cloud Storage Not Connected</h4>
                <p>Please connect your cloud storage to enable synchronization features.</p>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn-cancel" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn-connect">
                <i className="bi bi-cloud-plus me-2"></i>
                Connect Storage
              </button>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default EnvSetting;